module.exports = __webpack_public_path__ + "img/restaurante-1.a5e20a93.png";